import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { services } from '../data/site';
export function Services() {
  return <section id="services" className="w-full border-y border-line bg-mist py-24 lg:py-32" data-id="element-306" data-mp="1htta4zsn6qji">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-307" data-mp="1dw5axkjx2blt">
        <Reveal data-id="element-308" data-mp="18twiqqevbdkr">
          <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end" data-id="element-309" data-mp="18ug1g9cce5zu">
            <div data-id="element-310" data-mp="13wmqz440aptr">
              <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice" data-id="element-311" data-mp="13x63u6esuo0x">
                <span className="h-px w-8 bg-ice" aria-hidden="true" data-id="element-312" data-mp="z3bi6xfmvyz7" />
                What We Haul
              </p>
              <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-ink sm:text-4xl lg:text-[3.1rem]" data-id="element-313" data-mp="q4q4bfl3x84r">
                Built for Freight That Can&apos;t Wait.
              </h2>
            </div>
            <p className="max-w-sm text-base leading-relaxed text-ink-soft" data-id="element-314" data-mp="g7lixhz35gp0">
              Temperature, timing, and handling matter. Our equipment and drivers are prepared for demanding
              refrigerated and dry freight requirements.
            </p>
          </div>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-315" data-mp="2xd2tr948h9f6">
          {services.map((service, i) => <li key={service.title} className="h-full" data-id="element-316" data-mp="32be6pspts01m" data-mpi={i}>
              <Reveal delay={0.04 * i} className="h-full" data-id="element-317" data-mp="3pzxf088vkctp">
                <a href="#contact" className="group flex h-full flex-col rounded-2xl border border-line bg-white p-8 transition-[transform,border-color,box-shadow] duration-200 ease-premium hover:-translate-y-1.5 hover:border-ice/40 hover:shadow-[0_18px_50px_rgba(11,14,17,0.1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice focus-visible:ring-offset-2" data-id="element-318" data-mp="3pyckgimk8tvu">
                  <span className="inline-flex w-fit rounded-full bg-ice-100 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-ice-600" data-id="element-319" data-mp="29mqdnayu46di">
                    {service.temp}
                  </span>
                  <h3 className="mt-6 font-display text-xl font-bold uppercase leading-tight tracking-tight text-ink" data-id="element-320" data-mp="1li8yv7onhrwv">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-321" data-mp="1bsxq5m5oep9i">{service.description}</p>
                  <span className="mt-auto flex items-center gap-2 pt-8 text-[12px] font-bold uppercase tracking-[0.12em] text-ink transition-colors duration-150 ease-premium group-hover:text-ice" data-id="element-322" data-mp="16tcvhnxjh32l">
                    Learn More
                    <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-323" data-mp="xty6ksx0t0k7" />
                  </span>
                </a>
              </Reveal>
            </li>)}

          <li className="h-full" data-id="element-324" data-mp="2n7ut7zyp3ezv">
            <Reveal delay={0.2} className="h-full" data-id="element-325" data-mp="2n8w6mb36odkr">
              <div className="flex h-full flex-col justify-between rounded-2xl bg-ink p-8" data-id="element-326" data-mp="2n60amsawbyyy">
                <p className="font-display text-xl font-bold uppercase leading-tight tracking-tight text-white" data-id="element-327" data-mp="2upj9m80jc2t6">
                  Not sure where your freight fits?
                </p>
                <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-328" data-mp="34hyp8yod0faw">
                  Send us the commodity, lane, and set point — dispatch will confirm capacity.
                </p>
                <a href="#contact" className="group mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-ice px-6 py-3 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 ease-premium hover:bg-ice-600" data-id="element-329" data-mp="2bu2onivo638u">
                  Request a Quote
                  <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-330" data-mp="10gjcws5did4" />
                </a>
              </div>
            </Reveal>
          </li>
        </ul>
      </div>
    </section>;
}